/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDualScreen = createReactComponent("outline", "dual-screen", "IconDualScreen", [["path", { "d": "M5 4l8 3v15l-8 -3z", "key": "svg-0" }], ["path", { "d": "M13 19h6v-15h-14", "key": "svg-1" }]]);

export { IconDualScreen as default };
//# sourceMappingURL=IconDualScreen.mjs.map
